export function initHeader() {
    const headerElement = document.getElementById("site-header");
    const sentinel = document.getElementById("header-sentinel");
    if (!headerElement || !sentinel) return;

    const observer = new window.IntersectionObserver(
        ([entry]) => {
            headerElement.classList.toggle("at-top", entry.isIntersecting);
        },
        {
            root: null,
            threshold: 0,
        },
    );

    observer.observe(sentinel);
}

export function initCategoryMenu() {
    const list = document.getElementById("top-categories-list");
    if (!list) return;

    let lastWidth = window.innerWidth;
    let activeItem = list.querySelector("li.active");

    function adjustAlignment() {
        const hasOverflow = list.scrollWidth > list.clientWidth;
        const shouldCenter = !hasOverflow;

        // Only update classes if they need to change
        if (shouldCenter && !list.classList.contains("sm:justify-center")) {
            list.classList.remove("sm:justify-start");
            list.classList.add("sm:justify-center");
        } else if (!shouldCenter && !list.classList.contains("sm:justify-start")) {
            list.classList.remove("sm:justify-center");
            list.classList.add("sm:justify-start");
        }
    }

    function scrollToActive() {
        if (activeItem) {
            activeItem.scrollIntoView({
                behavior: "auto",
                block: "nearest",
                inline: "center",
            });
        }
    }

    let rafId;

    function handleResize() {
        const currentWidth = window.innerWidth;

        // Only adjust alignment if width actually changed
        if (currentWidth !== lastWidth) {
            cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                adjustAlignment();
                lastWidth = currentWidth;
            });
        }
    }

    // Initial setup
    adjustAlignment();

    // Scroll to active item after layout is complete (wait for CSS to be applied)
    if (activeItem) {
        requestAnimationFrame(scrollToActive);
    }

    // Handle resize for alignment adjustments - only when width changes
    window.addEventListener("resize", handleResize, { passive: true });
}
